import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementPayrollHistoryReport extends Layout {
    checkboxIncludeDeductionHistory: Checkbox;
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    payrollHistoryDatasource: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxPayeeType: Textbox;
}
